import AOS from "aos";
import lozad from "lozad";
import { header } from "./header";
import swiperInit from "./swiper";
import fancyboxInit from "./fancybox";
import { buttonToTop, toggleCta, headingMaskScroll } from "./helper";
import { productList } from "./product";
$(function () {
	header.init();
	swiperInit();
	lozadInit();
	fancyboxInit();

	buttonToTop();
	toggleCta();

	// Thêm event listener cho scroll để animate heading mask
	$(window).on('scroll', function() {
		headingMaskScroll();
	});

	// Gọi một lần khi trang load để set trạng thái ban đầu
	headingMaskScroll();

	productList();

	/*==================== Aos Init ====================*/
	AOS.init({
		// Global settings:
		disable: 'phone', // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
		startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
		initClassName: 'aos-init', // class applied after initialization
		animatedClassName: 'aos-animate', // class applied on animation
		useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
		disableMutationObserver: false, // disables automatic mutations' detections (advanced)
		debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
		throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)


		// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
		offset: 0, // offset (in px) from the original trigger point
		delay: 0, // values from 0 to 3000, with step 50ms
		duration: 400, // values from 0 to 3000, with step 50ms
		easing: 'ease', // default easing for AOS animations
		once: true, // whether animation should happen only once - while scrolling down
		mirror: true, // whether elements should animate out while scrolling past them
		anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

	});
	/*==================== Lazyload JS ====================*/
});


function lozadInit() {
	console.log("lozadInit");
	const observer = lozad(); // lazy loads elements with default selector as '.lozad'
	const backgroundObserver = lozad('.lozad-bg', {
		threshold: 0.1,
	});
	observer.observe();
	backgroundObserver.observe();
}
// window.lozadInitNew = lozadInit;
// $(function () {
// 	$('header a').on('click', function (e) {
// 		e.preventDefault();
// 	setTimeout(() => {
// 		window.lozadInitNew(); // Calling to initialize Lozad again when needed.
// 		}, 1000);
// 	});
// });
